module.exports = __webpack_public_path__ + "static/media/dm.664bf042.svg";